import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import ExpressMobile from "../../../assets/img/SolutionsIcons/AgilysysExpressMobile.svg";
import { Header } from "../../../components/Header";

const ExpressMobileFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return(
        <div className="page splash expressMobileFPage">
            <div className="page-title"><img src={ExpressMobile} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                A complete mobile check-in and check-out guest
experience with support for:{'\n\n'}
                </div>
                <div className="std-text">
                    <ul>
                        <li><div className="dot"/>Digital Keys</li>
                        <li><div className="dot"/>ID Verification</li>
                        <li><div className="dot"/>Key Encoding</li>
                        <li><div className="dot"/>Room Ready Messaging</li>
                    </ul>{'\n'}
                </div>
                <div className="std-text">
                With Express, guests can avoid long front desk lines and
enjoy a complete contactless process getting to their rooms
and the property's amenities faster. The result is reduced
lines at the front desk, greater staff productivity, and
reduced operating costs.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - Express Mobile", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/expressMobile1.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveExpressMobile.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default ExpressMobileFPage;